import React, { useState } from 'react';
import Modal from './Modal';
import api from '../api';

export default function EmailModal({
  an, anzeigeName, apiPfad, onClose, onSent,
  initialBetreff = '', initialNachricht = '', titel = 'E-Mail senden', hinweis = '', zusatzDaten = {},
}) {
  const [betreff, setBetreff] = useState(initialBetreff);
  const [nachricht, setNachricht] = useState(initialNachricht);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSend = async () => {
    if (!betreff.trim() || !nachricht.trim()) {
      setError('Betreff und Nachricht sind Pflichtfelder.');
      return;
    }
    setSending(true);
    setError('');
    try {
      await api.post(apiPfad, { ...zusatzDaten, betreff, nachricht });
      setSuccess(true);
      if (onSent) onSent();
    } catch (err) {
      setError(err.response?.data?.error || 'Fehler beim Senden der E-Mail.');
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal title={titel} onClose={onClose} size="md">
      {success ? (
        <div>
          <div className="alert alert-success">E-Mail wurde erfolgreich gesendet.</div>
          <div className="modal-actions">
            <button className="btn btn-secondary btn-sm" onClick={onClose}>Schließen</button>
          </div>
        </div>
      ) : (
        <>
          {hinweis && <div className="alert alert-info" style={{ fontSize: '0.85rem' }}>{hinweis}</div>}
          <div className="form-group">
            <label className="form-label">Empfänger</label>
            <div style={{
              padding: '0.5rem 0.75rem', background: 'var(--bg-light)',
              border: '1px solid var(--border)', borderRadius: 'var(--radius)',
              fontSize: '0.9rem', color: 'var(--text-muted)',
            }}>
              {anzeigeName ? `${anzeigeName} <${an}>` : an}
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Betreff <span style={{ color: 'var(--danger)' }}>*</span></label>
            <input
              type="text" className="form-control"
              value={betreff} onChange={e => setBetreff(e.target.value)}
              placeholder="Betreff eingeben…"
              autoFocus
            />
          </div>

          <div className="form-group">
            <label className="form-label">Nachricht <span style={{ color: 'var(--danger)' }}>*</span></label>
            <textarea
              className="form-control"
              value={nachricht} onChange={e => setNachricht(e.target.value)}
              rows={8}
              placeholder="Ihre Nachricht…"
            />
          </div>

          {error && <div className="alert alert-error">{error}</div>}

          <div className="modal-actions">
            <button className="btn btn-secondary btn-sm" onClick={onClose} disabled={sending}>Abbrechen</button>
            <button className="btn btn-primary btn-sm" onClick={handleSend} disabled={sending}>
              {sending ? 'Senden…' : '✉ E-Mail senden'}
            </button>
          </div>
        </>
      )}
    </Modal>
  );
}
